import React from 'react'
import { useTranslation } from 'react-i18next'

import teamAvatars from './Avatars'
import Member from './Member'

const MEMBERS_NAMES = [
  'Andreas',
  'Arslan',
  'Carmen',
  'Cj',
  'Franco',
  'Georg',
  'James',
  'Lee',
  'Lubing',
  'Mark',
  'Matthias',
  'Nick',
  'Urs',
  'Zoe'
]

function TeamInfo() {
  const { t } = useTranslation()
  const roles = t('landing.the_team.roles', { returnObjects: true })
  const careers = t('landing.the_team.careers', { returnObjects: true })
  const listRoles = [
    roles.gs_zh,
    roles.gss,
    roles.gs_zh,
    roles.business_partner,
    roles.gs_zh,
    roles.gs_zh,
    roles.gss,
    roles.gss,
    roles.gss,
    roles.business_partner,
    roles.gs_zh,
    roles.gs_zh,
    roles.gs_zh,
    roles.business_partner
  ]

  const listCareers = [
    `${careers.game_designer} / ${careers.master_facilitator}`,
    `${careers.game_designer} / ${careers.master_facilitator}`,
    `${careers.game_designer} / ${careers.master_facilitator}`,
    `${careers.senior_facilitator} / ${careers.consultant}`,
    `${careers.game_designer} / ${careers.master_facilitator}`,
    `${careers.game_designer} / ${careers.master_facilitator}`,
    `${careers.master_facilitator} / ${careers.workshop_leader}`,
    `${careers.facilitator} / ${careers.consultant}`,
    `${careers.master_facilitator} / ${careers.workshop_leader}`,
    `${careers.senior_facilitator} / ${careers.consultant}`,
    `${careers.game_designer} / ${careers.master_facilitator}`,
    `${careers.game_designer} / ${careers.master_facilitator}`,
    `${careers.game_designer} / ${careers.master_facilitator}`,
    `${careers.senior_facilitator} / ${careers.consultant}`,
  ]

  return (
    <div className="the-team">
      <div className="home__title-container">
        <div className="home__title">{t('landing.the_team.title')}</div>
      </div>
      <div className="the-team__wrapper">
        <div className="the-team__integrants-row">
          {MEMBERS_NAMES.slice(0, 4).map((name, index) => (
            <Member
              key={`team-member-${name}`}
              avatar={teamAvatars[index]}
              career={listCareers[index]}
              name={name}
              role={listRoles[index]}
            />
          ))}
        </div>
        <div className="the-team__integrants-row">
          {MEMBERS_NAMES.slice(4, 8).map((name, index) => (
            <Member
              key={`team-member-${name}`}
              avatar={teamAvatars[index + 4]}
              career={listCareers[index + 4]}
              name={name}
              role={listRoles[index + 4]}
            />
          ))}
        </div>
        <div className="the-team__integrants-row">
          {MEMBERS_NAMES.slice(8, 12).map((name, index) => (
            <Member
              key={`team-member-${name}`}
              avatar={teamAvatars[index + 8]}
              career={listCareers[index + 8]}
              name={name}
              role={listRoles[index + 8]}
            />
          ))}
        </div>
        <div className="the-team__integrants-row">
          {MEMBERS_NAMES.slice(12, MEMBERS_NAMES.length).map((name, index) => (
            <Member
              key={`team-member-${name}`}
              avatar={teamAvatars[index + 12]}
              career={listCareers[index + 12]}
              name={name}
              role={listRoles[index + 12]}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default TeamInfo
